import { lazy, memo, Suspense } from "react";
import { Button } from "react-bootstrap";
import CountUp from "react-countup";
import { useTranslation } from "react-i18next";

const ExpertsVideos = lazy(() => import("./ExpertsVideos"));

const PROFILE_IMG_SIZE = 80;
const BENEFITS = [
  {
    title: "Muslim Career Accelerator",
    description: "membership.youth.benefit1",
  },
  {
    title: "Muslim Mentor Academy",
    description: "membership.youth.benefit2",
  },
  {
    title: "Networking Event Access",
    description: "membership.youth.benefit3",
  },
  {
    title: "Access to the SMBF Network",
    description: "membership.youth.benefit4",
  },
  {
    title: "Facilitated Introductions",
    description: "membership.youth.benefit5",
  },
];

const LANDING_CLIP_STYLE: React.CSSProperties = {
  clipPath: "ellipse(180% 75% at 50% 25%)",
};
const CARD_CLIP_STYLE: React.CSSProperties = {
  clipPath: "ellipse(180% 75% at 50% 75%)",
};
const ICON_BOX_STYLE: React.CSSProperties = { minWidth: 40, height: 40 };

const SUSPENSE_FALLBACK_STYLE: React.CSSProperties = { minHeight: 320 };

function YouthMembership() {
  const { t } = useTranslation();
  return (
    <div className="w-100">
      <div
        style={LANDING_CLIP_STYLE}
        className="p-2 p-md-5 member-benefits-landing d-flex flex-column gap-3 justify-items-center justify-content-center text-white text-center"
      >
        <h5 className="d-inline-block blur-bg p-2 px-4 rounded-pill fs-5 fw-semibold text-White mx-auto">
          {t("membership.earlyStageTitle")}
        </h5>
        <h1 className="px-md-5 px-1 display-5 fw-bold">
          {t("membership.youth.heroTitle")}
        </h1>
        <p className=" px-md-5 px-1 fs-4 fw-semibold text-light">
          {t("membership.youth.heroSubtitle")}
        </p>
        <div>
          <Button className="px-5">{t("membership.viewBenefits")}</Button>
        </div>
        <div className="d-flex align-items-center justify-content-center gap-4 gap-md-5 text-white px-4 py-3">
          <div className="image-stack position-relative d-flex">
            <img
              src="/SMBF-23.jpeg"
              alt="SMBF youth members"
              className="profile-img z-2"
              width={PROFILE_IMG_SIZE}
              height={PROFILE_IMG_SIZE}
              loading="eager"
              decoding="async"
            />
            <img
              src="/SMBF-24.jpeg"
              alt="SMBF network"
              className="profile-img z-1 position-absolute second-img"
              width={PROFILE_IMG_SIZE}
              height={PROFILE_IMG_SIZE}
              loading="lazy"
              decoding="async"
            />
            <img
              src="/SMBF-25.jpeg"
              alt="SMBF community"
              className="profile-img z-2 position-absolute third-img"
              width={PROFILE_IMG_SIZE}
              height={PROFILE_IMG_SIZE}
              loading="lazy"
              decoding="async"
            />
          </div>
          <div className="ms-5 px-5">
            <h3 className="mb-0 fw-bold text-white">
              <CountUp end={5000} duration={1} separator="," suffix="+" />
            </h3>
            <h5 className="mb-0 text-light">{t("common.network")}</h5>
          </div>
        </div>
      </div>
      <div className="container py-4 d-flex gap-4 flex-column align-items-center justify-content-center">
        <h2>{t("membership.youth.whatYouGet")}</h2>
        {BENEFITS.map((item) => (
          <div
            key={item.title}
            className="benefit-container w-100 bg-primary bg-opacity-25 text-dark rounded-4 p-4 d-flex align-items-start gap-3"
          >
            <div
              className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center"
              style={ICON_BOX_STYLE}
            >
              <i className="bi bi-check-lg fs-5"></i>
            </div>
            <div>
              <h4 className="fw-bold mb-1">{item.title}</h4>
              <p className="fs-5">{t(item.description)}</p>
            </div>
          </div>
        ))}
        <h2>{t("membership.earlyStage.priceLine")}</h2>
        <Button className="px-5">{t("common.registerNow")}</Button>
      </div>
      <div
        style={CARD_CLIP_STYLE}
        className="card-bg px-3 py-4 px-md-10 py-md-5"
      >
        <div className="d-flex justify-content-center flex-column align-items-center mt-4 mt-md-5">
          <h2 className="fs-24 fs-md-40">
            {t("membership.youth.videoHeading")}
          </h2>
          <Suspense fallback={<div style={SUSPENSE_FALLBACK_STYLE} aria-hidden="true" />}>
            <ExpertsVideos />
          </Suspense>
          <h2 className="fs-24 fs-md-40 text-center px-5 mb-5">
            {t("membership.youth.ctaHeading")}
          </h2>
          <Button className="px-5">{t("common.registerNow")}</Button>
        </div>
      </div>
    </div>
  );
}

YouthMembership.displayName = "YouthMembership";

export default memo(YouthMembership);
